import React from 'react';
import { editUser } from '../apiCallsHelper/userapicalls';
import { isAuthenticated } from '../apiCallsHelper/authapicalls';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';



const AccountUpdate = ({ userDetails, handleInputChange, isDisableFirstname, handleSaveFirstname, handleEditFirstname, isDisableLastname, handleSaveLastname, handleEditLastname, isDisableEmail, handleSaveEmail, handleEditEmail, setIsCancel }) => {

    const { user, token } = isAuthenticated();

    const handleSubmit = (event) => {
        event.preventDefault();

        editUser(user._id, token, userDetails.fname, userDetails.lname, userDetails.email).then(data => {
            if (data.error) {
                toast.error(data.error);
                // console.log("data error", data.error)
            }
            else {
                toast.success(data.message);
                // console.log("Is it saved? ", isSaved)
                // console.log("data aftr updating: ", data)
            }

        })
    }



    const handleCancel = () => {
        setIsCancel(true);
    }



    return (
        <>
            <div className='w-[150px]    xs:w-[200px]    sm:w-[250px]    md:w-[520px]    smLaptop:w-[620px]   lg:w-[620px]   xl:w-[620px]     mx-auto  '>
                <div className='w-[150px]    xs:w-[200px]    sm:w-[250px]    md:w-[520px]    smLaptop:w-[620px]   lg:w-[620px]   xl:w-[620px]   mt-8 mb-4 text-xl text-center text-blue-900 font-bold '>Your Account</div>
                <div className=" w-[150px]    xs:w-[200px]    sm:w-[250px]    md:w-[400px]    smLaptop:w-[400px]   lg:w-[400px]   xl:w-[400px]   mx-auto  ">
                    <div className="flex flex-wrap -mx-3 mb-2 ">
                        <div className="w-full px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                htmlFor="grid-first-name">
                                First name
                            </label>

                            <input name="fname" value={userDetails.fname} onChange={handleInputChange}
                                className="py-2 px-2 mb-2      xs:py-2 xs:px-2 xs:mb-1   sm:py-2 sm:px-2 sm:mb-2   md:py-3 md:px-4 md:mb-3     smLaptop:py-3 smLaptop:px-4 smLaptop:mb-3      lg:py-3 lg:px-4 lg:mb-3    xl:py-3 xl:px-4 xl:mb-3   appearance-none block w-full bg-gray-200 text-gray-700 
                                border border-gray-200 rounded leading-tight 
                                focus:outline-blue-500 focus:bg-white"
                                disabled={isDisableFirstname ? 'disabled' : ''}
                                id="grid-first-name"
                                type="text"
                                placeholder="your firstname" />

                            <p onClick={() => handleSaveFirstname()}
                                className='text-green-600 text-sm float-right ml-2 cursor-pointer 
                                hover:text-green-900 hover:underline'>
                                save
                            </p>
                            <p onClick={() => handleEditFirstname()}
                                className='text-blue-600 text-sm float-right cursor-pointer 
                                hover:text-blue-900 hover:underline'>
                                edit
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-6">
                        <div className="w-full px-3">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                htmlFor="grid-last-name">
                                Last name
                            </label>
                            <input name="lname" value={userDetails.lname}
                                onChange={handleInputChange}
                                className="py-2 px-2 mb-2   xs:py-2 xs:px-2 xs:mb-1   sm:py-2 sm:px-2 sm:mb-2   md:py-3 md:px-4 md:mb-3     smLaptop:py-3 smLaptop:px-4 smLaptop:mb-3      lg:py-3 lg:px-4 lg:mb-3    xl:py-3 xl:px-4 xl:mb-3   appearance-none block w-full bg-gray-200 text-gray-700 
                                border border-gray-200 rounded leading-tight 
                                focus:outline-blue-500 focus:bg-white focus:border-gray-500"
                                disabled={isDisableLastname ? 'disabled' : ''}
                                id="grid-last-name"
                                type="text"
                                placeholder="your lastname"
                            />
                            <p onClick={() => handleSaveLastname()}
                                className='text-green-600 text-sm float-right ml-2 cursor-pointer 
                                hover:text-green-900 hover:underline'>
                                save
                            </p>
                            <p onClick={() => handleEditLastname()}
                                className='text-blue-600 text-sm float-right cursor-pointer 
                                hover:text-blue-900 hover:underline'>
                                edit
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-6">
                        <div className="w-full px-3">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                htmlFor="grid-email">
                                Email
                            </label>
                            <input name="email" value={userDetails.email} onChange={handleInputChange}
                                className="py-2 px-2 mb-2      xs:py-2 xs:px-2 xs:mb-1   sm:py-2 sm:px-2 sm:mb-2   md:py-3 md:px-4 md:mb-3     smLaptop:py-3 smLaptop:px-4 smLaptop:mb-3      lg:py-3 lg:px-4 lg:mb-3    xl:py-3 xl:px-4 xl:mb-3   appearance-none block w-full bg-gray-200 text-gray-700 
                                border border-gray-200 rounded leading-tight 
                                focus:outline-blue-500 focus:bg-white focus:border-gray-500"
                                disabled={isDisableEmail ? 'disabled' : ''}
                                id="grid-email"
                                type="email"
                                placeholder="xxx@email.com" />
                            <button className='bg-[#e1e9f0] rounded-full w-[16px] h-[16px] float-right' data-tooltip-id="userEmailUpdate-tooltip" data-tooltip-content="If you want to update your email, please reach out to todomateforyou@gmail.com">
                                <FontAwesomeIcon icon={faQuestion} size='xs' color='#8da0b3' className='pb-1' />
                                <Tooltip id="userEmailUpdate-tooltip" place="bottom" style={{ backgroundColor: "#e1e7f0", color: "#1f4578", padding: "2px 5px", fontSize: "12px" }} />
                            </button>
                            {/* <p onClick={() => handleSaveEmail()}
                                className='text-green-600 text-sm float-right ml-2 cursor-pointer 
                                hover:text-green-900 hover:underline'>
                                save
                            </p>
                            <p onClick={() => handleEditEmail()}
                                className='text-blue-600 text-sm float-right cursor-pointer 
                                hover:text-blue-900 hover:underline'>
                                edit
                            </p> */}
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-2">

                        <div className="w-full    text-xs      xs:text-sm   mobSm:text-sm   sm:text-sm    mobLg:text-sm    md:text-base      smLaptop:text-base        lg:text-base        xl:text-base          md:px-3">
                            <div className="float-right">
                                <button onClick={handleCancel}
                                    className=" py-2 px-4  xs:py-2 xs:px-4      mobLg:py-2 mobLg:px-6   md:py-2 md:px-6  lg:py-2 lg:px-6  xl:py-2 xl:px-6      bg-transparent hover:bg-red-500 text-red-500 font-semibold 
                                    hover:text-white border border-red-500 hover:border-transparent 
                                    rounded mr-2">
                                    Cancel
                                </button>
                                <button onClick={handleSubmit} className="py-2 px-4  xs:py-2 xs:px-4      mobLg:py-2 mobLg:px-6   md:py-2 md:px-6  lg:py-2 lg:px-6  xl:py-2 xl:px-6   bg-blue-500 hover:bg-blue-700 text-white 
                                    font-bold border border-blue-700 rounded ml-2">
                                    Save
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}



export default AccountUpdate